import { Flex, IconButton, Spacer } from '@chakra-ui/react'
import type { FC } from 'react'
import { PiArrowLeftBold } from 'react-icons/pi'

import { Tooltip } from '@app/components/ui/tooltip'
import useGetObject from '@app/hooks/useGetObject'
import ChatDeleteButton from '@app/pages/strategies/components/aiChat/components/chatDeleteButton'
import ContextLink from '@app/pages/strategies/components/aiChat/components/contextLink'
import DrawerCloseButton from '@app/shared/drawer/drawerCloseButton'

type Props = {
  chatId?: string
  onConfirmDelete?: () => void
  closable?: boolean
}

const ChatDrawerHeader: FC<Props> = ({ chatId, onConfirmDelete = () => {}, closable = false }) => {
  const chat = useGetObject(chatId, 'chat')

  return (
    <Flex p={2}>
      <Tooltip content="Go back">
        <IconButton aria-label="Go back" asChild colorPalette="gray" variant="ghost">
          <ContextLink to="list">
            <PiArrowLeftBold />
          </ContextLink>
        </IconButton>
      </Tooltip>
      <Spacer />
      {chatId && (
        <Tooltip content="Delete this chat">
          <ChatDeleteButton chat={chat} onConfirm={onConfirmDelete} />
        </Tooltip>
      )}
      {closable && <DrawerCloseButton variant="ghost" />}
    </Flex>
  )
}

export default ChatDrawerHeader
